export default {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:9000/api/v2',
  webAppBaseUrl: process.env.REACT_APP_WEB_APP_BASE_URL || 'http://localhost:3000',
  webSocketBaseUrl: process.env.REACT_APP_WEB_SOCKET_BASE_URL || 'ws://localHost:8000',
  jwtDurationInMinutes: 500,
  accountingWebAppBaseUrl: process.env.ACCOUNTING_WEB_APP_BASE_URL || 'http://localhost:3500',
  supportPhoneNumber: '+52 348 123 4128',
  inspectionsListsVersion: 3
};
